import { RouteRoles } from '@/router/role-routes';
import { RouteConfig } from 'vue-router';
import { validateIntegerParam } from '@/middleware/validateIntegerParam';
import { Organizations } from './types';

const routes: RouteConfig[] = [
  {
    path: `/${Organizations.Pages.ORGANIZATIONS}`,
    name: Organizations.Pages.ORGANIZATIONS,
    component: () => import(/* webpackChunkName: "organizations" */ './views/Organizations.vue'),
    meta: {
      access_roles: RouteRoles[Organizations.Pages.ORGANIZATIONS],
    },
  },
  {
    path: `/${Organizations.Pages.ORGANIZATIONS}/:id`,
    name: Organizations.Pages.ORGANIZATION_DETAIL,
    beforeEnter: validateIntegerParam('id'),
    component: () => import(/* webpackChunkName: "organization" */ './views/OrganizationDetail.vue'),
    meta: {
      access_roles: RouteRoles[Organizations.Pages.ORGANIZATION_DETAIL],
    },
  },
  {
    path: `/${Organizations.Pages.ORGANIZATIONS}/:id/edit`,
    name: Organizations.Pages.ORGANIZATION_EDIT,
    beforeEnter: validateIntegerParam('id'),
    component: () => import(/* webpackChunkName: "organization-edit" */ './views/OrganizationEditPage.vue'),
    meta: {
      access_roles: RouteRoles[Organizations.Pages.ORGANIZATION_EDIT],
    },
  },
  {
    path: `/${Organizations.Pages.ORGANIZATION_CHECK}`,
    name: Organizations.Pages.ORGANIZATION_CHECK,
    component: () => import(/* webpackChunkName: "organization-check" */ './views/OrganizationCheck.vue'),
    meta: {
      access_roles: RouteRoles[Organizations.Pages.ORGANIZATION_CHECK],
    },
  },
  {
    path: `/${Organizations.Pages.ORGANIZATIONS}/${Organizations.Pages.CONTRACTS}/:id`,
    beforeEnter: validateIntegerParam('id'),
    name: Organizations.Pages.CONTRACT_DETAIL,
    component: () => import(/* webpackChunkName: "organization" */ './components/contracts/ContractDetail.vue'),
    meta: {
      access_roles: RouteRoles[Organizations.Pages.ORGANIZATION_DETAIL],
    },
  },
];

export default routes;
